import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


// ** Fetch Users
export const fetchTextToImageThunk = createAsyncThunk(
    "fetchTextToImage",
    async (params, config) => {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL_LOCAL}/api/text-to-image/fetchAll`,
            params
        );

        return response.data;
    }
);

export const createTextToImageThunk  = createAsyncThunk(
    "createTextToImage",
    async ({ config, values }) => {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL_LOCAL}/api/text-to-image/create`,
            values, {
            headers: {
                ...config
            }
        }
        );
        return response.data;
    }
);

// delete Inspirations
export const deleteTextToImageThunk = createAsyncThunk(
    "deleteTextToImage",
    async ({ id }, { rejectWithValue }) => {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL_LOCAL}/api/text-to-image/delete/${id}`
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Error deleting Inspiration");
      }
    }
  );
  
  //   update Inspiration 
    export const updateTextToImageThunk = createAsyncThunk(
      "updateTextToImage",
      async ({ id, values }, { rejectWithValue }) => {
        try {
          const response = await axios.put(
            `${process.env.REACT_APP_API_URL_LOCAL}/api/text-to-image/update/${id}`,
            values
          );
          return response.data;
        } catch (error) {
          return rejectWithValue(error.response?.data || "Error updating tattoo");
        }
  
    }
  );
  
  // update order for shuffle data
  export const updateTextToImagePositionThunk = createAsyncThunk(
    "updateTextToImagePosition",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/text-to-image/shuffleData`, { id: id.order });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const sortTextToImageThunk=createAsyncThunk(
    "sortTextToImage",
    async ({ id,isSorted }, { rejectWithValue }) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL_LOCAL}/api/text-to-image/sort`,
          { id,isSorted }  // Ensuring correct API parameter
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Error updating order");
      }
    }
  )
  

export const textToImageSlice = createSlice({
    name: "textToImage ",
    initialState: {
        textToImages: [],
        total: 0,
        limit: 10,
        page: 1,
        pageCount: 0,
        isLoading: true,
    },
    reducers: {
        changeLimit: (state, action) => {
            state.limit = action.payload;
        },
        changePage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTextToImageThunk.fulfilled, (state, action) => {
            state.textToImages = action?.payload?.data?.textToImages;
            state.total = action?.payload?.data?.totalCount
            state.page = action?.payload?.data?.currentPage
            state.pageCount = action?.payload?.data?.totalPages
            state.isLoading = true;
        }).addCase(createTextToImageThunk.fulfilled, (state, action) => {
            // state.inspirations=action?.payload?.data?.inspiration
            // state.total=action?.payload?.data?.totalCount
            // state.page=action?.payload?.data?.currentPage
            // state.pageCount=action?.payload?.data?.totalPages

            // state.isLoading = true;
            // if (action?.payload?.code === 200) {
            //     state.users = action.payload?.body.users;
            //     state.total = action.payload?.body.total;
            //     state.isLoading = false;
            // }
        });


    },
});

export const { changeLimit, changePage } = textToImageSlice.actions;
export default textToImageSlice.reducer;
